// import { Box, Card, CardContent, CardMedia, Stack } from '@mui/material'
// import AsyncActionButton from '@src/components/AsyncActionButton'
// import { LanguagePicker } from '@src/components'
// import { JwtToken, useSignIn } from '@src/data/api/user-api/user-api'
// import { loadUserFromJwtString, saveUserToken } from '@src/data/providers/UserProvider'
// import { User } from '@src/data/types/User'
// import { useTranslation } from 'react-i18next'
// import { useNavigate } from 'react-router-dom'

// interface Props {
//   setUser: (u: User) => void
//   withBackdrop?: boolean
// }

// export default function LoginPage({ setUser }: Props) {
//   const { t } = useTranslation()
//   const navigate = useNavigate()
//   const signIn = useSignIn()
//   document.title = t('common.login')

//   const handleLogin = () => {
//     const fakeToken: JwtToken = {
//       jwt: '',
//     }
//     signIn.mutateAsync(fakeToken).then((token) => {
//       saveUserToken(token.jwt)
//       const user = loadUserFromJwtString(token.jwt)
//       setUser(user)
//       navigate('/home', { replace: true })
//     })
//   }

//   return (
//     <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
//       <Card>
//         <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//           <LanguagePicker />
//         </div>
//         <div style={{ display: 'flex', justifyContent: 'center' }}>
//           <CardMedia sx={{ width: '200px' }} component="img" image="/images/logo.svg" alt="iFinance" />
//         </div>
//         <CardContent>
//           <Stack spacing={3} sx={{ paddingLeft: '100px', paddingRight: '100px', paddingTop: '20px' }}>
//             <AsyncActionButton isLoading={signIn.isLoading} showLoading={true} onClick={handleLogin}>
//               {t('common.login')}
//             </AsyncActionButton>
//           </Stack>
//         </CardContent>
//       </Card>
//     </Box>
//   )
// }

//new version testing purpose to let user type person id
import { Box, Card, CardContent, CardMedia, Stack, TextField } from '@mui/material';
import AsyncActionButton from '@src/components/AsyncActionButton';
import { LanguagePicker } from '@src/components';
import { JwtToken, useSignIn } from '@src/data/api/user-api/user-api';
import { loadUserFromJwtString, saveUserToken } from '@src/data/providers/UserProvider';
import { User } from '@src/data/types/User';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react'

interface Props {
  setUser: (u: User) => void;
  withBackdrop?: boolean;
}

const LoginPage = ({ setUser }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const signIn = useSignIn();
  const [personId, setPersonId] = useState('');

  document.title = t('common.login');
  //possibility to enter person id / testing purposes
  const handleLogin = () => {
    const fakeToken: JwtToken = {
      jwt: '',
    };
    signIn.mutateAsync({ jwt: fakeToken.jwt, personId }).then((token) => {
      saveUserToken(token.jwt);
      const user = loadUserFromJwtString(token.jwt);
      setUser(user);
      navigate('/home', { replace: true });
    }).catch(error => {
      console.error("Login failed:", error);
    });
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Card>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <LanguagePicker />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CardMedia sx={{ width: '200px' }} component="img" image="/images/logo.svg" alt="iFinance" />
        </div>
        <CardContent>
          <Stack spacing={3} sx={{ paddingLeft: '100px', paddingRight: '100px', paddingTop: '20px' }}>
            <TextField
              fullWidth
              label={t('person id')}
              variant="outlined"
              value={personId}
              onChange={(e) => setPersonId(e.target.value)}
            />
            <AsyncActionButton isLoading={signIn.isLoading} showLoading={true} onClick={handleLogin}>
              {t('common.login')}
            </AsyncActionButton>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}

export default LoginPage
